import { render, staticRenderFns } from "./search-edit.vue?vue&type=template&id=63996492&scoped=true&"
import script from "./search-edit.vue?vue&type=script&lang=ts&"
export * from "./search-edit.vue?vue&type=script&lang=ts&"
import style0 from "./search-edit.vue?vue&type=style&index=0&id=63996492&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63996492",
  null
  
)

export default component.exports